import { motion } from "framer-motion";

import b1 from "./assets/real.png";
import b2 from "./assets/aut.png";
import b3 from "./assets/alert.png";

const OperationalCore = () => {
  const features = [
    {
      id: "capacity-collaboration",
      title: "Real-Time Capacity Monitoring & Seamless Team Collaboration",
      description:
        "View team workload live, track tasks, capacity, and distribute work fairly and efficiently.",
      icon: b1,
      bg: "bg-[#d3f8f2]",
    },
    {
      id: "automated-task",
      title: "Automated Task Assignment",
      description:
        "Reduce manual planning; the system assigns tasks based on skills, shifts, and priorities intelligently.",
      icon: b2,
      bg: "bg-[#eee8fd]",
    },
    {
      id: "dynamic-alerts",
      title: "Dynamic Adjustment Alerts",
      description:
        "Adapt instantly as the system recalculates workloads and suggests adjustments during unexpected events.",
      icon: b3,
      bg: "bg-[#e2fbe9]",
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 60 },
    show: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.2,
        duration: 0.7,
        ease: "easeOut",
      },
    }),
  };

  const iconVariants = {
    initial: { rotate: 0, scale: 1 },
    hover: {
      rotate: 10,
      scale: 1.1,
      transition: { duration: 0.3 },
    },
  };

  return (
    <div className="bg-white w-full font-epilogue px-6 md:px-10 lg:px-20 py-20 overflow-hidden">
     
      <div className="text-center mb-14 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          Core Functions of <br /> Workforce Scheduler
        </h2>
        <p className="text-gray-600 text-base md:text-lg leading-relaxed">
          The Workforce Scheduler optimizes task allocation and resource planning
          to ensure efficient and timely execution of operational activities.
        </p>
      </div>

      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {features.map((feature, index) => (
          <motion.div
            key={feature.id}
            className={`rounded-2xl p-8 ${feature.bg} text-center shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2`}
            variants={cardVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            custom={index}
            whileHover={{ scale: 1.03 }}
          >
            <motion.img
              src={feature.icon}
              alt={feature.title}
              className="mx-auto w-16 h-16 mb-6"
              variants={iconVariants}
              initial="initial"
              whileHover="hover"
            />

            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {feature.title}
            </h3>

            <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
              {feature.description}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default OperationalCore;
